import React from "react";
import { colors } from "../../../global";

export const AnalysisCard = ({
  title,
  value,
  description,
  icon: Icon,
  accentColor = colors.primary,
  insight,
}) => (
  <div
    className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 relative overflow-hidden"
    style={{ borderTop: `4px solid ${accentColor}` }}
  >
    <div
      className="absolute top-0 right-0 w-16 h-16 rounded-full opacity-5"
      style={{
        backgroundColor: accentColor,
        transform: "translate(8px, -8px)",
      }}
    />
    <div className="flex items-center justify-between mb-4">
      <div className="p-3 rounded-lg" style={{ backgroundColor: colors.gray }}>
        <div style={{ color: accentColor }}>
          <Icon />
        </div>
      </div>
      {insight && (
        <div
          className="flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium"
          style={{ backgroundColor: `${accentColor}15`, color: accentColor }}
        >
          {insight}
        </div>
      )}
    </div>

    <div className="space-y-2 relative z-10">
      <h3
        className="text-sm font-semibold tracking-wider uppercase"
        style={{ color: colors.darkGray }}
      >
        {title}
      </h3>
      <div className="text-3xl font-bold" style={{ color: colors.primary }}>
        {value}
      </div>
      {description && (
        <div className="text-sm text-gray-600">{description}</div>
      )}
    </div>
  </div>
);

export const FindingsSummary = ({ meta, displayPct }) => {
  const label =
    meta.state === "improved"
      ? "Cost Reduction Achieved"
      : meta.state === "flat"
      ? "No Change"
      : "Cost Increased";
  const color =
    meta.state === "improved"
      ? colors.success
      : meta.state === "flat"
      ? colors.info
      : colors.error;
  const pctAbs = typeof displayPct === "number" ? Math.abs(displayPct) : null;

  return (
    <div
      className="rounded-xl shadow-lg border border-gray-200 p-8 flex flex-col justify-center items-center text-center relative overflow-hidden"
      style={{ backgroundColor: colors.primary }}
    >
      <div
        className="absolute top-0 right-0 w-24 h-24 rounded-full opacity-10"
        style={{
          backgroundColor: colors.accent,
          transform: "translate(12px, -12px)",
        }}
      />
      <div
        className="absolute bottom-0 left-0 w-16 h-16 rounded-full opacity-5"
        style={{
          backgroundColor: colors.secondary,
          transform: "translate(-8px, 8px)",
        }}
      />

      <div className="relative z-10">
        <h2 className="text-lg font-semibold text-white mb-2">
          Analysis Results
        </h2>
        <p className="text-4xl font-bold text-white mb-2">
          {typeof pctAbs === "number"
            ? `${meta.state === "worse" ? "+" : "-"}${pctAbs.toFixed(2)}%`
            : "—"}
        </p>
        <div className="flex items-center justify-center gap-2">
          <div
            className="flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium"
            style={{ backgroundColor: `${color}1A`, color }}
          >
            <span>{label}</span>
          </div>
        </div>
        <p className="text-xs text-gray-300 mt-3">Based on CORA vs Incumbent</p>
      </div>
    </div>
  );
};
